import React, { useEffect, useState } from "react";
import toast from "react-hot-toast";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import Logo from "../assets/images/payloft-logo.png";
import { useNavigate, useParams } from "react-router-dom";
import { completeCreateUser } from "../services/userServices";

const CompleteRegistration = () => {
  const [decodeMail, setDecodeMail] = useState("");
  const [password, setPassword] = useState("");
  const [firstPassword, setFirstPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [passwordError, setPasswordError] = useState(""); // State for password error message
  const [inputPass, setInputPass] = useState("password");
  const [showPassword, setShowPassword] = useState(false);
  const [inputPassConfirm, setInputPassConfirm] = useState("password");
  const [showConfirm, setShowConfirm] = useState(false);
  const email = useParams();
  const navigate = useNavigate();

  // Function to validate password
  const validatePassword = (firstPassword) => {
    // Regular expressions for validation
    const hasNumber = /\d/;
    const hasSpecialChar = /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]+/;

    // Check password length, presence of number, and special character
    if (
      firstPassword.length < 9 ||
      !hasNumber.test(firstPassword) ||
      !hasSpecialChar.test(firstPassword)
    ) {
      throw new Error(
        "Password must be at least 9 characters long and contain a number and a special character."
      );
    }
  };

  const handleCreateUser = async (e) => {
    e.preventDefault();
    if (firstPassword !== confirmPassword) {
      toast.error("Passwords do not match");
      return;
    }
    try {
      // Validate password again before submission
      validatePassword(firstPassword);

      const res = await completeCreateUser({
        emailAddress: decodeMail,
        password: firstPassword,
      });
      console.log(res);
      toast.success(res.message);
      navigate("/");
    } catch (error) {
      if (error.response) {
        toast.error(error.response.data.message);
      }
    }
  };

  const handleShowPassword = () => {
    setShowPassword(!showPassword);
    setInputPass(inputPass === "password" ? "text" : "password");
  };

  const handleShowConfirm = () => {
    setShowConfirm(!showConfirm);
    setInputPassConfirm(inputPassConfirm === "password" ? "text" : "password");
  };

  useEffect(() => {
    const decodedEmail = atob(email.email);
    setDecodeMail(decodedEmail);
  }, [email.email]);

  const handlePasswordChange = (e) => {
    const newPassword = e.target.value;
    setFirstPassword(newPassword);
    // Validate password
    try {
      validatePassword(newPassword);
      setPasswordError(""); // Clear error message if validation passes
    } catch (error) {
      setPasswordError(error.message); // Set error message if validation fails
    }
  };

  return (
    <div className="flex justify-center">
      <div className="w-[448px] p-4">
        <div className="flex items-center justify-center">
          <img
            src={window.__TENANT__?.logo ?? Logo}
            alt="logo"
            className="w-[92px] h-auto"
          />
        </div>
        <h1 className="text-[25px] font-semibold border-b pb-20 text-center mt-20">
          Create Password
        </h1>
        <div className="flex flex-col">
          <form onSubmit={handleCreateUser}>
            <div className="flex flex-col mt-6 ">
              <label htmlFor="email">Email Address</label>
              <input
                type="email"
                name="email"
                value={decodeMail}
                className="focus:outline-none h-[50px] bg-form-background p-2 text-navy-blue rounded-md mt-2"
                disabled
              />
            </div>
            <div className="flex flex-col mt-6 relative">
              <label htmlFor="new-password">Password</label>
              <input
                type={inputPass}
                id="password"
                onChange={
                  handlePasswordChange
                } /* Updated to handlePasswordChange */
                placeholder="......."
                className="focus:outline-none h-[50px] bg-form-background p-2 text-navy-blue rounded-md mt-2"
                // onChange={(e) => setFirstPassword(e.target.value)}
              />
              {passwordError && (
                <span className="text-xs text-red-500">{passwordError}</span>
              )}
              {/* Display password error */}
              <button
                type="button"
                className="absolute right-4 top-12"
                onClick={handleShowPassword}
              >
                {showPassword ? <FaEyeSlash /> : <FaEye />}{" "}
              </button>
            </div>
            <div className="flex flex-col mt-4 relative">
              <label htmlFor="confirm-password">Confirm Password</label>
              <input
                type={inputPassConfirm}
                id="confirm-password"
                placeholder="....."
                className="focus:outline-none h-[50px] bg-form-background p-2 text-navy-blue rounded-md mt-2"
                onChange={(e) => setConfirmPassword(e.target.value)}
              />
              <button
                type="button"
                className="absolute right-4 top-12"
                onClick={handleShowConfirm}
              >
                {showConfirm ? <FaEyeSlash /> : <FaEye />}{" "}
              </button>
            </div>
            <div className="mt-4">
              <p className="font-normal text-[13px] text-gray-400">
                Characteristics of strong passwords
              </p>
              <p className="text-[13px] font-normal mt-4">
                At least 8 characters-the more characters, the better.
              </p>
              <p className="text-[13px] font-normal">
                A mixture of both uppercase and lower letters.
              </p>
              <p className="text-[13px] font-normal">
                A mixture of letters and numbers.
              </p>
              <p className="text-[13px] font-normal">
                Inclusion of at least one special character e.g. !@#?&#93;
              </p>
              <p className="text-gray-400 text-[13px] font-normal mt-6 w-[348px]">
                {" "}
                Note: do not use &lt; or &gt; in your password, as both can
                cause problems in Web browsers.
              </p>
            </div>
            <div className="mt-8">
              <button
                disabled={passwordError}
                className="bg-primary text-white w-full xl:w-[448px] h-[50px] rounded-md disabled:bg-[rgba(var(--primary-rgb),0.3)]"
                type="submit"
              >
                Create Account
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default CompleteRegistration;
